import React, {Fragment, useEffect, useState} from 'react'
import {Button, Form, Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import DatosTercero from './contactoTercero'
import { LoadingComponent } from 'recupero-comunes'
import {configuracionFormAction15, configuracionFormAction24, obtenerComboModoContactoModal, obtenerComboRespuestaContactoModal, obtenerGrillaHistorial, obtenerGrillaHitos, obtenerUltimoContacto, postActualizarContactoAction} from '../../store/actions/contacto-tercero-action'
import {useFormik} from 'formik'
import Historial from './historial'

import { validationSchemas } from '../../common/validation-Shemas-modal-contacto'
import { obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import { obtenerDatosGestion } from '../../store/actions/cambio-gestion-action'
const ContactoTerceroModal = ({ handleClose, idCaso,idImplicado,idOrganizacionCaso }) => {
    const [loading, setLoading]=useState(false)
    const data_recepciona = useSelector((state) => state.casoGeneralReducer)
    const { llaves} = data_recepciona
    const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
  const {datosGestion} = data_traza_modal
    const [isModoContacto, setIsModoContacto] = React.useState(false);
    const [isModoRespuesta, setIsModoRespuesta] = React.useState(false);
    const [showToast, setShowToast] = React.useState(false);
    const [isHistorial, setIsHistorial] = React.useState(false)
    const dispatch = useDispatch()
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 
    useEffect(() => {     

         dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
      
      }, [dispatch])
    useEffect(() => {
      if(llaves) { 
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
            rutcia: llaves && llaves['idOrgCaso'],
            idform: 15
        })).toString('base64')
        dispatch(configuracionFormAction15(query))
        .then(()=>{
            let query = Buffer.from(JSON.stringify({
                rutcia: llaves && llaves['idOrgCaso'],
                idform: 24
            })).toString('base64')
            dispatch(configuracionFormAction24(query))
        })
        .then(()=>{
            let query = Buffer.from(
                JSON.stringify({idCaso:llaves && llaves["idCaso"], idImplicado: llaves && llaves["idImplicado"]})
              ).toString('base64')
              dispatch(obtenerDatosGestion(query))
        })
        .then(()=>{
            let query = Buffer.from(
                JSON.stringify({idCaso:llaves && llaves["idCaso"], idImplicado: llaves && llaves["idImplicado"]})
              ).toString('base64')
              dispatch(obtenerUltimoContacto(query))
        })
        .then(()=>{
            setLoading(false)
        })
    }
    }, [dispatch,llaves])
   
    
   
   useEffect(()=>{
       if (llaves && datosGestion) {
        let query = Buffer.from(JSON.stringify({
            idCaso: llaves && llaves["idCaso"],
            idImplicado: llaves && llaves["idImplicado"],
            idModoIngreso1: 238002,
            idModoIngreso2: 238003,
            tipoGestion: datosGestion && datosGestion.datosGestion[0] !== undefined && datosGestion.datosGestion[0]['codTipoGestion'],
            ambitoGestion: datosGestion && datosGestion.datosGestion[0] !== undefined && datosGestion.datosGestion[0]['codAmbitoGestion'],
            responsableReasignado: false
        })).toString('base64')
        dispatch(obtenerGrillaHitos(query))
    }
   },[dispatch,datosGestion,llaves])
        
      
      
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idCarpetaResExt": null,
            "codTipoGestion": "",
            "codAmbitoGestion": "",
            "glosaAmbitoGestion": null,
            "codIntanciaGestion": null,
            "fechaAudiencia": null,
            "codHitoContacto": "",
            "fechaHitoContacto": "",
            "minutaHitoContacto": "",
            "codHitoRespuesta": "",
            "fechaHitoRespuesta": "",
            "minutaHitoRespuesta": "",
            "recepciona": "0",
            "aliasApp": null,
            "idUsuario": ""


        },
         validationSchema: validationSchemas(isModoContacto, isModoRespuesta),
        onSubmit: (formData) => {
            const dataForm = {
                ...formData
            }
            dataForm["idCaso"] = llaves && llaves["idCaso"]
            dataForm["idImplicadoCaso"] = llaves && llaves["idImplicado"]
            dataForm["idOrganizacion"] = llaves && llaves["idOrgCaso"]
            dataForm["idUsuario"] = llaves && llaves["idUsuario"]
            dataForm["codTipoGestion"] = datosGestion && datosGestion.datosGestion[0]["codTipoGestion"]
            dataForm["codAmbitoGestion"] = datosGestion && datosGestion.datosGestion[0]["codAmbitoGestion"]
          
            dispatch(postActualizarContactoAction(dataForm)).then(()=>historialF())
            setIsHistorial(true)
            handleShowToast()
        }
    })
    
    return (
        <>
            <LoadingComponent show={loading}/>
                <Form onSubmit={
                    formik.handleSubmit
                }>
                    <DatosTercero formik={formik}
                     setIsModoContacto={setIsModoContacto} 
                     setIsModoRespuesta={setIsModoRespuesta}
                     showToast={showToast}
                     setShowToast={setShowToast}
                     />
                    <Historial handleClose={handleClose}
                    setIsHistorial={setIsHistorial}
                    isHistorial={isHistorial}
                        formik={formik}/>
                </Form>
            
        </>
    )
}

export default ContactoTerceroModal
